var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Shown in place of the analysis-steps chip on an answer that called no tools.
 *
 * Without it those answers are indistinguishable in the UI, yet they sit either side of
 * the line that matters: one had real rows in context to answer from, the other had
 * nothing retrieved behind it at all. The steps chip covers the third case
 * ('retrieved'), so this component never renders for it.
 */
var GroundingMarker = /** @class */ (function (_super) {
    __extends(GroundingMarker, _super);
    function GroundingMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GroundingMarker.prototype, "text", {
        // Says what is actually known, which is that no tool ran this turn — not that the
        // replayed rows were used. Nothing observable distinguishes an answer that read them
        // from one that ignored them (a definition question, say, replied to mid-conversation
        // with rows still in context), so the label stops at the verifiable part and the
        // tooltip explains which case it is.
        get: function () {
            return this.grounding === 'context'
                ? this.strings.noNewLookup
                : this.strings.noDataRetrieved;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GroundingMarker.prototype, "hint", {
        get: function () {
            return this.grounding === 'context'
                ? this.strings.noNewLookupHint
                : this.strings.noDataRetrievedHint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GroundingMarker.prototype, "iconClass", {
        get: function () {
            return this.grounding === 'context' ? 'fas fa-history' : 'fas fa-ban';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true })
    ], GroundingMarker.prototype, "grounding", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], GroundingMarker.prototype, "strings", void 0);
    GroundingMarker = __decorate([
        Component
    ], GroundingMarker);
    return GroundingMarker;
}(Vue));
export default GroundingMarker;
